import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "mesh-component-library";
import { find, isEmpty, map } from "lodash";
import { datadogRum } from "@datadog/browser-rum";
import Loader from "../../components/loader";
import {
  benefitsLookupStart,
  clearCCardInfo,
  clearServiceTypeOptions,
  refreshReducersToInitial,
  requestPartnerDetails,
  updateBenefitsFlag,
  updateBusinessName,
  updateCCardInfo,
  updateCurrentLocation,
  updateFirstName,
  updateIsPrimaryLookup,
  updateLastName,
  updateLoggedInFlag,
  updatePartnerDetailsExperience,
  updatePpuFlag,
  updatePpuFuelPrice,
  updateServiceInfo,
  updateServiceTransition,
  updateCustomerType,
  CustomerType,
} from "../../action";
import FormOption from "../../components/form-option";
import Icon from "../../components/icon";
import ModalDialogAlt from "../../components/modal-dialog-alt";
import { SelectablePanel } from "../../components/selectable-panel";
import ServiceCancelled from "../../components/service-cancelled";
import FeedbackConfirmation from "../../components/feedback-confirmation";
import CarAnn from "../../components/svg/CarAnn";
import Benefits from "../../components/membershipBenefits";
import { saveRescueDetails, sendJacadaRequest } from "../../api";
import CommonBenefits from "../../aop/commonBenefits";
import {
  getServiceDetails,
  hasPepSessionSelector,
  isPayPerUseSelector,
  partnerDetailsLoadedSelector,
} from "../../selector";
import CONSTANTS, {
  ACTIVE_MEMBERSHIP_STATUSES,
  BENEFITS_USED_UP,
  CHANGE_TIRE,
  DISPLAY_TRIAGE_STEPS_STATUSES,
  FERRARI,
  FUEL_DELIVERY,
  GAS,
  JUMP_START,
  LOCKOUT,
  NOT_COVERED_PPU_STATUSES, PAYLOAD_NEW,
  SERVICE_CHANGE_ORIGIN,
  SERVICE_LIMIT,
  SERVICE_UNAVAILABLE,
  TIRE_CHANGE,
  TOW, TRIAGE_TYPE,
} from "../../app-consts/appConstants";
import { generatePath, generatePathWithSearchParams } from "../../utilities/RedirectUtils";
import { LocaleConsumer } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";
import { errorTranslatedText, serviceTranslatedText } from "../../utils/translatedTextUtils";
import AlertModal from "../../components/alertmodal";
import PricingInfoModal from "./modal/PricingInfoModal";
import { convertToBoolean } from "../../utils/regexUtil";
import { getInitialPartnerDetails } from "../../reducers/reducer-partner-details";
import clearCache from "../../utils/clearCache";
import { determinePPU } from "../../utils/determinePPU";
import { getGHRPromotionFlag, getOmniStreamlinedFlag } from "../../features/FeatureFlags";
import { RootState } from "../../reducers";
import { PartnerDetailsStore } from "../../types";
import { ServiceDetailState } from "../../reducers/reducer-service-details";
import {isABGPartner} from "../../utils";

type HomeProps = {
  benefitsLookupStart: (data: any, history: any) => void;
  clearCCardInfo: () => void;
  clearServiceTypeOptions: () => void;
  commonBenefits: any;
  hasPepSession: boolean;
  history: any;
  isDollarBased?: boolean;
  isMilesBased?: boolean;
  isPayPerUse: boolean;
  isPpuEnabled?: boolean;
  omniStreamlined: string;
  partnerCode: string;
  partnerDetails: PartnerDetailsStore;
  partnerDetailsLoaded: boolean;
  refreshReducersToInitial: () => void;
  requestPartnerDetails: (partnerCode: string) => void;
  serviceDetails: ServiceDetailState;
  serviceInfo: any;
  serviceRequestPayload: any;
  submitRequest: any;
  updateBenefitsFlag: (data: any) => void;
  updateBusinessName: (data: string) => void;
  updateCCardInfo: (data: any) => void;
  updateCurrentLocation: (data: any) => void;
  updateFirstName: (data: string) => void;
  updateIsPrimaryLookup: (data: any) => void;
  updateLastName: (data: string) => void;
  updateLoggedInFlag: (data: any) => void;
  updatePartnerDetailsExperience: (data: any) => void;
  updatePpuFlag: (data: any) => void;
  updatePpuFuelPrice: (data: any) => void;
  updateServiceInfo: (data: any) => void;
  updateServiceTransition: (data: any) => void;
  updateCustomerType: (data: CustomerType) => void;
  userType: string;
  isGHRPromotionEnabled: boolean;
};

type ContinueAsPPUState = {
  active: boolean;
  service: string | null;
};

type HomeState = {
  feedbackConfirmation: boolean;
  helpMeChooseButtonDisabled: boolean;
  helpMeChooseModal: boolean;
  helpMeChooseOption?: string;
  homeStatic: boolean;
  phoneLookup: boolean;
  ppuFuelPrice: number;
  rescueCancelled: boolean;
  showContinueAsPPUForServiceModal: ContinueAsPPUState;
  showPricingInfoModal: boolean;
};

export class Home extends Component<HomeProps, HomeState> {
  constructor(props: HomeProps) {
    super(props);
    this.state = {
      feedbackConfirmation: false,
      helpMeChooseButtonDisabled: false,
      helpMeChooseModal: false,
      helpMeChooseOption: undefined,
      homeStatic: false,
      phoneLookup: false,
      ppuFuelPrice: 0,
      rescueCancelled: false,
      showContinueAsPPUForServiceModal: {
        active: false,
        service: null,
      },
      showPricingInfoModal: false,
    };
  }

  componentDidMount() {
    const {
      benefitsLookupStart,
      commonBenefits,
      history,
      omniStreamlined,
      partnerCode,
      partnerDetails,
      partnerDetailsLoaded,
      requestPartnerDetails,
      submitRequest,
      updateBenefitsFlag,
      updateBusinessName,
      updateCustomerType,
      updateFirstName,
      updateLastName,
      userType,
    } = this.props;

    datadogRum.addAction("User lands on service selection page", { partnerCode, userType });
    document.title = "Home | Roadside Assistance";
    window.scrollTo(1, 1);

    if (commonBenefits?.errorMessage === CONSTANTS.MUST_CALL_FOR_WEIGHT_CLASS) {
      this.rerouteToServiceTransition();
    }

    if (submitRequest?.success) {
      this.rerouteToTracker();
    }

    if (partnerCode && !partnerDetailsLoaded && !partnerDetails.error) {
      requestPartnerDetails(getInitialPartnerDetails().displayCode);
    }

    if (userType === "ppu" && omniStreamlined) {
      const data = {
        guestFlow: true,
      };
      benefitsLookupStart(data, history);
    }

    if (userType === "ppu") {
      this.props.updatePpuFlag("Y");
      this.props.updateIsPrimaryLookup(true);
    }
    if (userType === "benefits" || userType === "ppu") {
      let cancelMessageFlag = localStorage.getItem("isPpu");
      localStorage.setItem("isPpu", cancelMessageFlag);
    }

    if (localStorage.getItem("rescueCancel") === "YES") {
      this.setState({ rescueCancelled: true });
      localStorage.setItem("rescueCancel", "NO");
    }
    if (localStorage.getItem("feedbackConfirmation") === "YES") {
      this.setState({ feedbackConfirmation: true });
      localStorage.setItem("feedbackConfirmation", "NO");
    }
    if (localStorage.getItem("firstName") !== null && localStorage.getItem("lastName") !== null) {
      updateFirstName(localStorage.getItem("firstName"));
      updateLastName(localStorage.getItem("lastName"));
    }
    if (localStorage.getItem("businessName") !== null) {
      updateBusinessName(localStorage.getItem("businessName"));
    }
    if (localStorage.getItem("customerType") !== null) {
      const storedType = localStorage.getItem("customerType");
      if (storedType === "customer" || storedType === "militaryBase") {
        updateCustomerType(storedType);
      }
    }
    if (
      ACTIVE_MEMBERSHIP_STATUSES.includes(commonBenefits.status?.toUpperCase()) &&
      !isEmpty(this.props.partnerDetails?.partnerDetails) &&
      !this.props.partnerDetails?.partnerDetails?.experience?.claimsExhausted
    ) {
      updateBenefitsFlag(true);
      this.props.clearCCardInfo();
      this.props.updatePpuFlag("N");
    }
  }

  componentDidUpdate() {
    const {
      commonBenefits,
      partnerDetails: { partnerDetails },
      updatePartnerDetailsExperience,
    } = this.props;
    if (
      commonBenefits.benefits &&
      JSON.stringify(partnerDetails.experience) !== JSON.stringify(commonBenefits.experience)
    ) {
      updatePartnerDetailsExperience(commonBenefits.experience);
    }

    this.rerouteUserIfNeeded();
  }

  rerouteToTracker = () => {
    const { history, partnerCode, omniStreamlined, submitRequest } = this.props;
    const { sessionId, callId, requestId, usageId } = submitRequest.response;
    if (!omniStreamlined && usageId && sessionId && callId && requestId) {
      history.push(generatePath(`tracker/${sessionId}/${callId}/${requestId}/${usageId}`));
    } else if (!!omniStreamlined && callId && usageId && partnerCode) {
      history.replace(generatePathWithSearchParams(`/wd/l/${partnerCode}/${callId}/${usageId}`));
    } else {
      clearCache(() => this.props.refreshReducersToInitial());
      datadogRum.addAction("Recovered from tracker redirection from Home page");
      return;
    }
  };

  rerouteToServiceTransition = () => {
    this.props.history.push(generatePath("ServiceTransition"));
  };

  rerouteUserIfNeeded = () => {
    const { partnerDetails, commonBenefits, isPayPerUse } = this.props;

    if (
      (commonBenefits.error === true && commonBenefits.unauthorized?.response?.status === 401) ||
      (partnerDetails && partnerDetails.status === 401)
    ) {
      let newURL = window.location.origin + "/login";
      let search = window.location.search;
      window.location.replace(newURL + search);
    } else if (commonBenefits.error || partnerDetails.error) {
      this.props.history.push(generatePath("sitedown"));
    }

    if (
      commonBenefits.experience?.coverageFollowsVehicle &&
      commonBenefits.vehicles?.length === 0 &&
      !commonBenefits.noBenefits
    ) {
      this.props.history.push(generatePath("memberlookup"));
    }
    if (commonBenefits.noBenefits && !partnerDetails.partnerDetails?.experience?.passThruEnabled && !isPayPerUse) {
      this.rerouteToServiceTransition();
    }
  };

  _onChangeDispatcher = async (event) => {
    // currentTarget is the service button even when the click lands on its inner text.
    let payload = event.currentTarget?.value ?? event.target.value;
    let payload_new = payload;
    let Service_ID;
    let Event_ID;
    let shouldRemoveServiceChangeOrigin = false;

    if (payload === FUEL_DELIVERY) {
      payload_new = GAS;
      Service_ID = 7;
      Event_ID = 25;
    } else if (payload === TIRE_CHANGE) {
      payload_new = CHANGE_TIRE;
      Service_ID = 44;
      Event_ID = 138;
      shouldRemoveServiceChangeOrigin = true;
    } else if (payload === TOW) {
      Service_ID = 45;
      Event_ID = 52;
    } else if (payload === LOCKOUT) {
      Service_ID = 24;
      Event_ID = "";
      shouldRemoveServiceChangeOrigin = true;
    } else {
      payload_new = "Battery";
      Service_ID = 23;
      Event_ID = "";
      shouldRemoveServiceChangeOrigin = true;
    }

    if (shouldRemoveServiceChangeOrigin) {
      localStorage.removeItem(SERVICE_CHANGE_ORIGIN);
    }

    let eventsData = [];
    eventsData.push(
      {
        name: "svc_id",
        value: Service_ID,
      },
      {
        name: "event_id",
        value: Event_ID,
      },
      {
        name: "SVC_DETL_TYPE_ID",
        value: "",
      },
      {
        name: "flat_tire_type_id",
        value: "",
      }
    );
    let jacadaRequestData = {
      externalSystemId: localStorage.getItem("conversationId"),
      events: eventsData,
    };
    sendJacadaRequest(jacadaRequestData);
    datadogRum.addAction(`${payload} Selected`);
    datadogRum.addAction("Service Type Selected", { eventsData });

    localStorage.setItem(PAYLOAD_NEW, payload_new);
    localStorage.setItem(TRIAGE_TYPE, payload);
    let services = this.props.commonBenefits.services;
    localStorage.setItem("services", JSON.stringify(services));

    let selectedService = find(services, ["type", payload_new]);
    this.props.updateIsPrimaryLookup(false);
    const partnerDetails = this.props.partnerDetails.partnerDetails;
    const excludedServiceTypes = partnerDetails?.experience?.excludedServiceTypes;

    if (this.props.omniStreamlined && this.props.isPayPerUse) {
      this.props.updatePpuFlag("Y");
    }
    this.props.clearServiceTypeOptions();
    if (excludedServiceTypes?.includes(payload) || excludedServiceTypes?.includes(payload_new)) {
      datadogRum.addAction(
        `User navigated to Service Transition by clicking ${payload} service for ${partnerDetails.partnerCode} partner`
      );
      this.props.updateServiceTransition({
        serviceType: payload,
        declineType: SERVICE_UNAVAILABLE,
      });
      this.rerouteToServiceTransition();
    } else if (
      this.props.isPpuEnabled === false &&
      selectedService &&
      Number(selectedService.claimCount) >= Number(selectedService.maxClaimCount) &&
      partnerDetails.experience?.coverageFollowsService
    ) {
      this.props.updateServiceTransition({
        serviceType: payload_new,
        declineType: SERVICE_LIMIT,
      });
      this.rerouteToServiceTransition();
    } else if (
      this.props.isPpuEnabled === true &&
      selectedService &&
      Number(selectedService.claimCount) >= Number(selectedService.maxClaimCount) &&
      this.props.partnerDetails.partnerDetails.experience?.coverageFollowsService
    ) {
      this.setState({
        showContinueAsPPUForServiceModal: { active: true, service: payload },
      });
    } else {
      await this.gotoLocation(payload);
    }
  };

  gotoLocation = async (payload) => {
    const {
      omniStreamlined,
      serviceInfo,
      commonBenefits,
      partnerDetails: {
        partnerDetails: { experience, partnerCode },
      },
      serviceRequestPayload,
    } = this.props;
    if (omniStreamlined) {
      if (serviceRequestPayload.sessionId.includes("-")) {
        await saveRescueDetails(serviceRequestPayload, partnerCode, "", this.props.history, () =>
          this.props.refreshReducersToInitial()
        );
        return;
      } else {
        saveRescueDetails(serviceRequestPayload, partnerCode, "", this.props.history, () =>
          this.props.refreshReducersToInitial()
        );
      }
    }

    const ppuFuelPrice = localStorage.getItem("ppuFuelPrice");
    let service = find(this.props.serviceDetails.serviceDetails, ["serviceText", payload]);
    determinePPU(this.props, service);
    serviceInfo["value"] = payload;
    serviceInfo["displayCost"] = service.displayCost;
    localStorage.setItem("serviceText", payload);
    this.props.updateServiceInfo(service);

    if (this.props.isPayPerUse) {
      this.props.updateCCardInfo({ transactionAmount: service.originalCost });
    }
    if (ppuFuelPrice) {
      if (serviceInfo.value === FUEL_DELIVERY) {
        this.props.updatePpuFlag("Y");
        this.props.updateCCardInfo({ transactionAmount: ppuFuelPrice });
      } else {
        this.props.updatePpuFlag("N");
        this.props.updateCCardInfo({ transactionAmount: "" });
      }
    }
    const hasConnectedVehicle = () => {
      let benefitsVehicles = commonBenefits?.vehicles?.length > 0 ? commonBenefits.vehicles : [];
      return benefitsVehicles.some((vehicle) => convertToBoolean(vehicle.vehiclePropID));
    };
    if (
      DISPLAY_TRIAGE_STEPS_STATUSES.includes(commonBenefits.status) &&
      (payload === JUMP_START ||
        (payload === LOCKOUT && hasConnectedVehicle()) ||
        payload === FUEL_DELIVERY ||
        payload === TIRE_CHANGE)
    ) {
      this.props.history.push(generatePath("triage-steps"));
    } else if (payload === TIRE_CHANGE || payload === LOCKOUT || payload === JUMP_START) {
      this.props.history.push(generatePath("triage"));
    } else if (!isABGPartner(partnerCode) && payload === TOW && experience?.towTriageEnabled) {
      this.props.history.push(generatePath("triage"));
    } else if (isABGPartner(partnerCode) && payload === TOW && experience?.towTriageEnabled) {
      this.props.history.push(generatePath("getStarted"));
    } else if (experience?.schedulingEnabled) {
      this.props.history.push(generatePath("ScheduleService"));
    } else {
      this.props.updateCurrentLocation({ setFromLocationServices: false });
      this.props.history.push(generatePath("disablementlocation"));
    }
  };

  openHelpMeChoose = () => {
    this.setState({
      helpMeChooseModal: true,
      homeStatic: true,
    });
  };

  closeHelpMeChoose = () => {
    this.setState({
      homeStatic: false,
      helpMeChooseModal: false,
    });
  };

  enableHelpMeChooseModalButton = (event) => {
    const option = event.target.value;
    this.setState({ helpMeChooseOption: option });
    this.setState({ helpMeChooseButtonDisabled: true });
  };

  continueToTow = () => {
    this.props.updateIsPrimaryLookup(false);
    this.props.history.push(generatePath(`help/${this.state.helpMeChooseOption}`));
  };

  renderSpinnerModal = () => {
    // loading isn't a property by default, is only added once it starts loading and then goes to false when it's finished
    const { commonBenefits } = this.props;
    if (commonBenefits && commonBenefits.commonBenefitLoading) {
      return (
        <div className="c-overlay has-loader is-fixed">
          <Loader className="c-loader--xl c-loader--position c-loader--spinner" />
        </div>
      );
    }
  };

  suspendedBtnCancel = () => {
    this.setState({
      showContinueAsPPUForServiceModal: {
        active: false,
        service: null,
      },
    });
  };

  suspendedBtnGuest = () => {
    datadogRum.addAction("PPU Policy Eligibility", {
      ppuEligibilityReason: "benefits_used_up",
      coverageFollowsService: true,
      partnerCode: this.props.partnerDetails?.partnerDetails?.partnerCode,
      serviceType: this.state.showContinueAsPPUForServiceModal.service,
      callId: this.props.serviceRequestPayload?.sessionId,
    });
    this.setState({
      showContinueAsPPUForServiceModal: { active: false, service: null },
    });

    this.props.updatePpuFlag("Y");
    let originalCost = this.props.serviceDetails?.serviceDetails.filter(
      (detail) => detail.serviceText === this.state.showContinueAsPPUForServiceModal.service
    )[0].originalCost;
    this.props.updateCCardInfo({ transactionAmount: originalCost });
    this.props.updateLoggedInFlag("N");
    this.gotoLocation(this.state.showContinueAsPPUForServiceModal.service);
  };

  checkForElectricVehicle = (serviceType, commonBenefits) =>
    serviceType === GAS &&
    commonBenefits.vehicles?.length === 1 &&
    commonBenefits.vehicles[0].fuelType &&
    typeof commonBenefits.vehicles[0].fuelType === "string" &&
    commonBenefits.vehicles[0].fuelType.toLowerCase() === "electric";

  renderServiceDetails = (isAllServicesCoverageAmountSame: boolean, getTranslatedText, serviceDetail) => {
    const { commonBenefits, isMilesBased } = this.props;
    let { isPayPerUse } = this.props;
    const { experience } = commonBenefits;
    const { serviceType } = serviceDetail;
    let serviceEnabled = true;

    // Disable fuel delivery for electric vehicles
    if (this.checkForElectricVehicle(serviceType, commonBenefits)) {
      serviceEnabled = false;
    }

    let mileageBenefits = null;
    let coverageUsedUpMessage = null;
    if (commonBenefits?.benefits && commonBenefits?.services?.length) {
      if (serviceType === TOW && (isMilesBased || experience?.variableCoverage)) {
        const coveredMilesValue = commonBenefits.services.filter((service) => service.type === TOW)[0]?.towIncludedQty;
        const isCoveredMilesLimited = coveredMilesValue && coveredMilesValue !== "N/A" ? coveredMilesValue : null;
        const mileUnitKey = Number(coveredMilesValue) === 1
          ? TRANSLATION_CONSTANTS.MILE
          : TRANSLATION_CONSTANTS.MILES;
        mileageBenefits = isCoveredMilesLimited
          ? `${getTranslatedText(TRANSLATION_CONSTANTS.SERVICE_COVERAGE_UPTO)} ${coveredMilesValue} ${getTranslatedText(
              mileUnitKey
            )}`
          : null;
      }

      if (serviceType === GAS) {
        let gasService = commonBenefits.services.filter((service) => service.type === GAS)[0];
        if (gasService?.fuelPaymentRequired) {
          const fuelPrice = this.determineFuelPriceByCountry(gasService);
          if (!isNaN(fuelPrice)) {
            const formatFuelPrice = Math.abs(fuelPrice).toFixed(2);
            this.props.updatePpuFuelPrice(formatFuelPrice);
            localStorage.setItem("ppuFuelPrice", formatFuelPrice);
            mileageBenefits = `${getTranslatedText(TRANSLATION_CONSTANTS.FUEL_PRICE)} $${fuelPrice}`;
          }
        }
      }
    }
    const currentService = commonBenefits?.services?.filter((service) => service.type === serviceType)[0];
    if (
      commonBenefits.experience?.dollarBased &&
      !commonBenefits.experience?.serviceBased &&
      !isAllServicesCoverageAmountSame
    ) {
      const coverageAmountService = currentService?.coverageAmount;

      if (coverageAmountService)
        mileageBenefits = `${getTranslatedText(TRANSLATION_CONSTANTS.SERVICE_COVERAGE_UPTO)} $${coverageAmountService}`;
    }

    if (commonBenefits.experience?.coverageFollowsService && commonBenefits?.services?.length) {
      const serviceFiltered = commonBenefits.services.filter((service) => service.type === serviceType)[0];
      const coverageUsedUp = serviceFiltered ? serviceFiltered.claimCount >= serviceFiltered.maxClaimCount : false;
      if (coverageUsedUp) {
        coverageUsedUpMessage = getTranslatedText(TRANSLATION_CONSTANTS.CLAIMS_USED_UP);
      }
      if (
        (coverageUsedUp || commonBenefits?.status?.toUpperCase() === BENEFITS_USED_UP) &&
        commonBenefits.experience?.ppuEnabled
      ) {
        isPayPerUse = true;
        mileageBenefits = null;
      } else {
        isPayPerUse = false;
      }
    }

    if (experience?.ppuEnabled && NOT_COVERED_PPU_STATUSES.includes(commonBenefits?.status?.toUpperCase())) {
      isPayPerUse = true;
      mileageBenefits = null;
    }

    let [pricingLabel, outOfPocketPricing, price] = this.determinePricing(
      getTranslatedText,
      serviceDetail,
      currentService,
      serviceType
    );
    const serviceErrorMessage = outOfPocketPricing ? outOfPocketPricing : coverageUsedUpMessage;
    if (pricingLabel) {
      mileageBenefits = null;
    }

    if (!mileageBenefits && !pricingLabel && !serviceErrorMessage && experience?.variableCoverage) {
      pricingLabel = currentService?.status || "";
    }

    const { id, serviceText, icon, iconSize, displayCost } = serviceDetail;
    const serviceDisplayText = this.getServiceDisplayText(serviceText, getTranslatedText);

    // Hide price for Ferrari PPU view when user is logged in
    const { partnerDetails } = this.props;
    const isFerrari = partnerDetails.partnerDetails?.oemVehicleMakesList?.includes(FERRARI);

    const hideFerrariPpuPrice =
      isFerrari &&
      isPayPerUse;
    return (
      serviceEnabled && (
        <div className="l-grid__col" key={id + serviceText}>
          <SelectablePanel
            ariaLabel={serviceDisplayText}
            text={serviceDisplayText}
            price={hideFerrariPpuPrice ? "" : (isPayPerUse ? displayCost : price)}
            pricingLabel={hideFerrariPpuPrice ? "" : pricingLabel}
            name="radiooptions"
            id={serviceText}
            value={serviceText}
            type="button"
            role="link"
            onClick={this._onChangeDispatcher}
            onKeyDown={(e) => {
              if (e.keyCode === 13) {
                this._onChangeDispatcher(e);
              }
            }}
            containerClass="d-flex"
            serviceClass="flex-item-1-grow-1"
            mileageBenefits={mileageBenefits}
            errorMessage={serviceErrorMessage}
          >
            <Icon icon={icon} size={iconSize} className="panel-icon flex-item-2" color="brand" aria-hidden="true" />
            <div className="flex-item-3"></div>
          </SelectablePanel>
        </div>
      )
    );
  };

  determinePricing = (getTranslatedText, serviceDetail, currentService, serviceType) => {
    const { commonBenefits, isDollarBased, isMilesBased } = this.props;
    if (isEmpty(commonBenefits?.status)) {
      return ["", "", ""];
    }
    const { experience = {}, amcCoverageAmount = "" } = commonBenefits;
    const { serviceBased = false, variableCoverage = false } = experience;
    const serviceStatus = currentService?.status ?? "";
    const { displayCost = 0 } = serviceDetail;
    let pricingLabel = "";
    let outOfPocketPricing = "";
    let price = "";
    const benefitStatus = commonBenefits?.status?.toUpperCase() ?? "";
    if (benefitStatus === CONSTANTS.MUST_SHOW_NO_BENEFITS_PRICING_INFO) {
      pricingLabel = getTranslatedText(TRANSLATION_CONSTANTS.START_AT_PRICING_INFO);
      price = displayCost;
    } else if (serviceBased && serviceStatus === CONSTANTS.SERVICE_STATUS_COVERED && !amcCoverageAmount) {
      const unlimitedServices = experience?.unlimitedServices ?? [];
      if (
        (!variableCoverage && !isDollarBased && isMilesBased && serviceType !== TOW) ||
        unlimitedServices.includes(serviceType)
      ) {
        pricingLabel = getTranslatedText(TRANSLATION_CONSTANTS.SERVICE_COVERED);
      } else if (isDollarBased && variableCoverage && parseInt(currentService.coverageAmount) === 9999990) {
        pricingLabel = getTranslatedText(TRANSLATION_CONSTANTS.SERVICE_COVERED);
      } else if (isDollarBased || (variableCoverage && serviceType !== TOW)) {
        pricingLabel = getTranslatedText(TRANSLATION_CONSTANTS.SERVICE_COVERAGE_UPTO);
        price = `${currentService.coverageAmount ?? ""}`;
      }
    } else if (serviceBased && serviceStatus === CONSTANTS.SERVICE_STATUS_NOT_COVERED) {
      outOfPocketPricing = getTranslatedText(TRANSLATION_CONSTANTS.OUT_OF_POCKET).replace("{{price}}", `$${displayCost}`);
    }

    return [pricingLabel, outOfPocketPricing, price];
  };

  determineFuelPriceByCountry = (gasService) => gasService.fuelQty * gasService.unitCostGallons;

  getServiceDisplayText = (serviceText: string, getTranslatedText: (key: string) => string) => {
    const { partnerCode } = this.props;

    if (serviceText === LOCKOUT && isABGPartner(partnerCode)) {
      return getTranslatedText(TRANSLATION_CONSTANTS.LOCKOUT_LOST_KEYS);
    }

    return getTranslatedText(serviceTranslatedText(serviceText));
  };

  renderCancelled = (getTranslatedText) => {
    let wasPpu = localStorage.getItem("isPpu");

    const messageText =
      wasPpu && wasPpu === "true"
        ? getTranslatedText(TRANSLATION_CONSTANTS.TAKE_UP_5_DAYS_CREDIT_REFUND)
        : getTranslatedText(TRANSLATION_CONSTANTS.CANCEL_REQUEST_SUCCESFULLY);

    return (
      <div>
        <ServiceCancelled messageText={messageText} />
      </div>
    );
  };

  renderFeedbackConfirmation = () => (
    <div>
      <FeedbackConfirmation />
    </div>
  );

  determineBenefits = () => {
    const {
      commonBenefits,
      partnerDetails: {
        partnerDetails: { experience },
      },
      isPayPerUse,
      isDollarBased,
      isMilesBased,
      hasPepSession,
    } = this.props;
    const { rescueCancelled } = this.state;

    let showBenefitsSection = false;

    if (!isPayPerUse) {
      localStorage.setItem("commonBenefits", JSON.stringify(commonBenefits));
    }

    if (!isPayPerUse) {
      if (isDollarBased && !isMilesBased) {
        showBenefitsSection = true;
      }
      localStorage.setItem("memberId", commonBenefits.memberId);
      if (commonBenefits.status === CONSTANTS.MUST_SHOW_NO_BENEFITS_PRICING_INFO) {
        showBenefitsSection = true;
      }
    } else {
      localStorage.removeItem("memberId");
      if (experience?.benefitsEnabled) {
        showBenefitsSection = !rescueCancelled;
      }
      if (hasPepSession) {
        showBenefitsSection = true;
      }
    }

    return {
      showBenefitsSection,
      benefitsMessage: commonBenefits.errorMessage,
    };
  };

  showPricingInfoModal = () => {
    this.setState({
      showPricingInfoModal: true,
    });
  };

  closePricingInfoModal = () => {
    this.setState({
      showPricingInfoModal: false,
    });
  };

  render() {
    const { showContinueAsPPUForServiceModal, showPricingInfoModal } = this.state;
    const {
      omniStreamlined,
      serviceDetails,
      commonBenefits,
      partnerCode,
      isPayPerUse,
      isPpuEnabled,
      partnerDetails = {} as PartnerDetailsStore,
      isGHRPromotionEnabled
    } = this.props;

    let showBenefitsSection = false;
    let benefitsMessage;
    if (
      (commonBenefits?.commonBenefitLoading === false &&
        commonBenefits?.error === false &&
        !commonBenefits.noBenefits) ||
      (commonBenefits?.noBenefits && isPayPerUse)
    ) {
      ({ showBenefitsSection, benefitsMessage } = this.determineBenefits());
      if (isGHRPromotionEnabled) {
        benefitsMessage = CONSTANTS.GHR_PROMOTION_MESSAGE_KEY;
        showBenefitsSection = true;
      }
    }

    const showServiceBasedBanner = commonBenefits?.services?.some((currentService) => {
      const serviceStatus = currentService?.status ?? "";
      return serviceStatus === CONSTANTS.SERVICE_STATUS_NOT_COVERED;
    });

    const isAllServicesCoverageAmountSame = commonBenefits?.services?.every((service: { coverageAmount: string; }) => service?.coverageAmount === commonBenefits?.services?.[0]?.coverageAmount);

    let showOmniDarkBanner = !!omniStreamlined;
    return (
      <LocaleConsumer>
        {(getTranslatedText) => (
          <div>
            <CommonBenefits history={this.props.history} />
            <div role="main" className={`l-container-home ${this.state.homeStatic ? " static" : ""}`}>
              {this.renderSpinnerModal()}
              <CarAnn />
              {this.state.rescueCancelled &&
                (isPpuEnabled || partnerDetails?.partnerDetails?.experience?.passThruEnabled) &&
                this.renderCancelled(getTranslatedText)}
              {this.state.feedbackConfirmation ? this.renderFeedbackConfirmation() : ""}

              <h1 id="how-can-we-help-you" className={`l-container-home__hd u-vrh-3 u-hr-2 u-hr-2-left`}>
                {getTranslatedText(TRANSLATION_CONSTANTS.HOW_HELP_TEXT)}
              </h1>

              <div className="l-container-home__bd">
                {showBenefitsSection || partnerCode !== "ETL" ? null : this.renderSpinnerModal()}
                {showBenefitsSection || showServiceBasedBanner ? (
                  <Benefits
                    benefitsAmt={commonBenefits.coverageAmount}
                    message={getTranslatedText(errorTranslatedText(benefitsMessage))}
                    showServiceBasedBanner={showServiceBasedBanner}
                    showOmniDarkBanner={showOmniDarkBanner}
                    handleOnClick={this.showPricingInfoModal}
                    isAllServicesCoverageAmountSame={isAllServicesCoverageAmountSame}
                  />
                ) : null}
                <div className="l-grid u-hr u-hr-left">
                  {/* Render service details here */}
                  {map(serviceDetails.serviceDetails, this.renderServiceDetails.bind(this, isAllServicesCoverageAmountSame, getTranslatedText))}
                  {showContinueAsPPUForServiceModal.active && (
                    <AlertModal
                      title={"Claims Used Up"}
                      content={"You may continue and pay for just today's service."}
                      primaryButton="CONTINUE"
                      primaryButtonCallback={this.suspendedBtnGuest}
                      secondaryButton="CANCEL"
                      secondaryButtonCallback={this.suspendedBtnCancel}
                    />
                  )}
                  <div className="service-selection-notes-container">
                    <button onClick={this.openHelpMeChoose} id="more-options-link" className="help-me-choose-text">
                      {getTranslatedText(TRANSLATION_CONSTANTS.MORE_OPTIONS)}
                    </button>
                  </div>
                </div>

                <ModalDialogAlt
                  id="choosehelp"
                  title={getTranslatedText(TRANSLATION_CONSTANTS.TELL_WHICH_BEST_DESCRIBES_SITUATION)}
                  isSlideDrawer
                  hideTrigger
                  showCloseBtn={true}
                  isActive={this.state.helpMeChooseModal}
                  onClose={this.closeHelpMeChoose.bind(this)}
                  footer={
                    this.state.helpMeChooseButtonDisabled ? (
                      <Button
                        size="lg"
                        hasUpgrade
                        id="call-continue"
                        onClick={this.continueToTow}
                        utils={{
                          fullWidth: true,
                        }}
                      >
                        {getTranslatedText(TRANSLATION_CONSTANTS.CONTINUE)}
                      </Button>
                    ) : null
                  }
                >
                  <div className="text_left">
                    <FormOption
                      label={getTranslatedText(TRANSLATION_CONSTANTS.STUCK_IN_DITCH)}
                      value="stuck"
                      name="helpmechoose"
                      type="radio"
                      onClick={this.enableHelpMeChooseModalButton}
                      onKeyDown={(e) => {
                        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
                          this.enableHelpMeChooseModalButton(e);
                        }
                      }}
                    />

                    <div className="u-vr-1-top" />

                    <FormOption
                      label={getTranslatedText(TRANSLATION_CONSTANTS.CAR_NEEDS_RECHARGING)}
                      value="recharge"
                      name="helpmechoose"
                      type="radio"
                      onClick={this.enableHelpMeChooseModalButton}
                      onKeyDown={(e) => {
                        if (e.keyCode === 38 || e.keyCode === 40 || e.keyCode === 13) {
                          this.enableHelpMeChooseModalButton(e);
                        }
                      }}
                    />

                    <div className="u-vr-1-top" />
                  </div>
                </ModalDialogAlt>
                <PricingInfoModal
                  showModal={showPricingInfoModal}
                  handleOnClose={this.closePricingInfoModal}
                  serviceDetails={serviceDetails?.serviceDetails || []}
                />
              </div>
            </div>
          </div>
        )}
      </LocaleConsumer>
    );
  }
}

const mapStateToProps = (state: RootState) =>
  ({
    commonBenefits: state.commonBenefits,
    hasPepSession: hasPepSessionSelector(state),
    isDollarBased: state.partnerDetails.partnerDetails.experience?.dollarBased,
    isMilesBased: state.partnerDetails.partnerDetails.experience?.milesBased,
    isPayPerUse: isPayPerUseSelector(state),
    isPpuEnabled: state.partnerDetails.partnerDetails.experience?.ppuEnabled,
    omniStreamlined: getOmniStreamlinedFlag(state),
    partnerCode: state.partnerDetails.partnerDetails.displayCode,
    partnerDetails: state.partnerDetails,
    partnerDetailsLoaded: partnerDetailsLoadedSelector(state),
    serviceDetails: getServiceDetails(state),
    serviceInfo: state.serviceInfo,
    serviceRequestPayload: state.serviceRequestPayload,
    submitRequest: state.submitRequest,
    userType: state.partnerDetails.partnerDetails.route,
    isGHRPromotionEnabled: getGHRPromotionFlag(state)
  } as Pick<
    HomeProps,
    | "commonBenefits"
    | "hasPepSession"
    | "isDollarBased"
    | "isMilesBased"
    | "isPayPerUse"
    | "isPpuEnabled"
    | "omniStreamlined"
    | "partnerCode"
    | "partnerDetails"
    | "partnerDetailsLoaded"
    | "serviceDetails"
    | "serviceInfo"
    | "serviceRequestPayload"
    | "submitRequest"
    | "userType"
  >);

const mapDispatchToProps = {
  benefitsLookupStart,
  clearCCardInfo,
  clearServiceTypeOptions,
  refreshReducersToInitial,
  requestPartnerDetails,
  updateBenefitsFlag,
  updateBusinessName,
  updateCCardInfo,
  updateCurrentLocation,
  updateFirstName,
  updateIsPrimaryLookup,
  updateLastName,
  updateLoggedInFlag,
  updatePartnerDetailsExperience,
  updatePpuFlag,
  updatePpuFuelPrice,
  updateServiceInfo,
  updateServiceTransition,
  updateCustomerType
} as Pick<
  HomeProps,
  | "benefitsLookupStart"
  | "clearCCardInfo"
  | "clearServiceTypeOptions"
  | "refreshReducersToInitial"
  | "requestPartnerDetails"
  | "updateBenefitsFlag"
  | "updateBusinessName"
  | "updateCCardInfo"
  | "updateCurrentLocation"
  | "updateFirstName"
  | "updateIsPrimaryLookup"
  | "updateLastName"
  | "updateLoggedInFlag"
  | "updatePartnerDetailsExperience"
  | "updatePpuFlag"
  | "updatePpuFuelPrice"
  | "updateServiceInfo"
  | "updateServiceTransition"
  | "updateCustomerType"
>;

export default connect(mapStateToProps, mapDispatchToProps)(Home);
